import React, { InputHTMLAttributes } from "react";
import { BiSearchAlt } from "react-icons/bi";
import { SearchInput, SerachInputWrapper } from "./searchinputbox.styles";

type ISearchInputBox = InputHTMLAttributes<HTMLInputElement> & {
  type: string
  placeholder: string
  name: string
}

const SearchInputBox: React.FC<ISearchInputBox> = ({
  type,
  name,
  placeholder,
  ...props
}) => {
  return (
    <SerachInputWrapper>
      <BiSearchAlt
        style={{ position: 'absolute', top: 11, left: 18 }}
        color={'#707070'}
      />
      <SearchInput
        type={type}
        name={name}
        placeholder={placeholder}
        {...props}
      />

    </SerachInputWrapper>

  )
}

export default SearchInputBox
